<template>
  <v-container id="meeting-list">
    <v-row>
      <v-col>
        <app-city-combobox :filter="filter"></app-city-combobox>
      </v-col>

      <v-col>
        <app-consultant-combobox
          :filter="filter"
          v-if="isAdmin"
        ></app-consultant-combobox>
      </v-col>

      <v-col>
        <v-btn outlined color="primary" class="ml-3" @click="getTasks()">
          <span>Filtrar</span>
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-data-table
          :headers="headers"
          :items="payload"
          class="elevation-1"
          hide-default-footer
          disable-pagination
        >
          <template slot="no-data">
            <span> Nenhuma {{ isAT ? "Atividade" : "Tarefa" }} retornada </span>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { AppConsultantCombobox } from "@/modules/user";
import { AppCityCombobox, cityTaskAPI } from "@/modules/city";

export default {
  components: {
    AppCityCombobox,
    AppConsultantCombobox,
  },
  computed: {
    ...mapGetters(["isAdmin", "user", "isAT"]),
  },
  data() {
    return {
      headers: [
        { text: "Nome", value: "nome" },
        { text: "Descrição", value: "descricao" },
        { text: "Horas", value: "horas" },
        { text: "Data de Finalização", value: "dataFinalizacaoString" },
        { text: "Data de Conclusão", value: "dataConclusaoString" },
        { text: "Município", value: "municipio.nome" },
        { text: "Solução", value: "municipioSolucao.nome" },
        { text: "Status", value: "execucaoTarefa" },
      ],
      payload: [],
      filter: {},
    };
  },
  methods: {
    ...mapActions(["setLoading"]),
    getTasks() {
      this.setLoading(true);
      if (!this.isAdmin) this.filter.usuarioId = this.user.usuarioId;
      cityTaskAPI
        .getTasksProgress(this.filter)
        .then((resp) => {
          this.payload = resp.data;
          this.setLoading(false);
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao obter tarefas");
        });
    },
  },
  mounted() {
    this.getTasks();
  },
};
</script>
